import React from "react";
import { createBrowserRouter } from "react-router-dom";

import {
  ErrorPage,
  HomePage,
  LoginPage,
  ModulePage,
  ComponentPage,
  UserPage,
  AuxiliaryComponentPage,
  AuxiliaryComponentsPage,
  ProductionStepEntryPage,
  ImportCernDBPage,
  MakeReportsPage,
  NewModulePage,
  ModulesPage,
  NotFoundPage,
  UpNextPage,
} from "@pages";

const errorElement = <ErrorPage />;

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    errorElement,
  },
  {
    path: "/login",
    element: <LoginPage />,
    errorElement,
  },
  {
    path: "/upnext",
    element: <UpNextPage />,
    errorElement,
  },
  {
    path: "/modules",
    element: <ModulesPage />,
    errorElement,
  },
  {
    path: "/modules/new",
    element: <NewModulePage />,
    errorElement,
  },

  {
    path: "/modules/:moduleId",
    element: <ModulePage />,
    errorElement,
  },
  {
    path: "/components/:componentSerial",
    element: <ComponentPage />,
    errorElement,
  },
  {
    path: "/users/:userId",
    element: <UserPage />,
    errorElement,
  },
  {
    path: "/auxiliary-components",
    element: <AuxiliaryComponentsPage />,
    errorElement,
  },
  {
    path: "/auxiliary-components/:auxiliaryComponentSerial",
    element: <AuxiliaryComponentPage />,
    errorElement,
  },
  {
    path: "/production/:productionStep",
    element: <ProductionStepEntryPage />,
    errorElement,
  },
  {
    path: "/import-cern-db",
    element: <ImportCernDBPage />,
    errorElement,
  },
  {
    path: "/make-reports",
    element: <MakeReportsPage />,
    errorElement,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export { router };
